import { Button } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import * as React from 'react';
import { globalColors } from '../../styles/globalColorVariables';

interface NvdButtonProps {
  label: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  endIcon?: React.ReactNode;
  href?: string;
  target?: React.HTMLAttributeAnchorTarget;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  variant?: 'contained' | 'outlined' | 'text';
}

const buttonStyle = {
  textTransform: 'none',
  borderRadius: '1.5rem',
  border: '1px solid',
  padding: '10px 13px 10px 16px',
  borderColor: globalColors.primaryColor
};

const NvdButton: React.FC<NvdButtonProps> = ({ variant, label, onClick, endIcon, href, sx, target, disabled }) => (
  <Button
    variant={variant}
    aria-controls={label}
    size='large'
    onClick={onClick}
    href={href}
    endIcon={endIcon}
    {...(href && { target, rel: 'noreferrer' })}
    disabled={disabled}
    sx={{ ...buttonStyle, ...sx }}
  >
    {label}
  </Button>
);

NvdButton.defaultProps = {
  variant: 'contained',
  onClick: undefined,
  endIcon: undefined,
  href: undefined,
  sx: undefined,
  disabled: false,
  target: '_blank'
};

export default NvdButton;
